import * as React from 'react';
import clsx from 'clsx';
import { Base } from '@gandi/ui';
var styles = {
  "root": "Footer-root_34TbS",
  "content": "Footer-content_19hYc"
};
function Footer(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Base, {
    tagName: "footer",
    boxSizing: "border",
    backgroundColor: "white",
    className: clsx(styles.root, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children));
}
export default Footer;